import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { useLogout } from 'common/services/hooks';
import { useChangeRequestParams } from './hooks';

type P = {
  children: ReactNode;
};

const ChangeRequestLogoutGuard = ({ children }: P): ReactNode => {
  const logout = useLogout();
  const { changeRequestId } = useChangeRequestParams();

  useEffect(() => {
    if (changeRequestId) {
      void logout();
    }
  }, [changeRequestId, logout]);

  if (changeRequestId) {
    return null;
  }

  return children;
};

export default ChangeRequestLogoutGuard;
